<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAdminSetupStore } from '@/store/AdminSetupStore';
import { useToast } from 'primevue/usetoast';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import EmailConfigNumber from '@/components/configuration/EmailConfigNumber.vue';

const isLoading = ref(false);
const { t } = useI18n({ useScope: 'global' });
const toast = useToast();
const adminSetupStore = useAdminSetupStore();
const listEmailNoti = ref([]);
const listConfigDate = ref([]);

const moveToEnd = (array: any, index: number) => {
  if (index < 0 || index >= array.length) {
    return;
  }
  const [item] = array.splice(index, 1);
  array.push(item);
};

const splitArrayByKey = (listData: any) => {
  const currentData = listData[0] ? listData[0] : listData;
  listEmailNoti.value = [];
  listConfigDate.value = [];
  for (const key in currentData) {
    let dataObject = {};
    if (key.startsWith('email')) {
      dataObject = { ...currentData[key], keyName: key };
      listEmailNoti.value.push(dataObject);
    } else {
      dataObject = { ...currentData[key], keyName: key };
      listConfigDate.value.push(dataObject);
    }
  }
  moveToEnd(listConfigDate.value, 1);
};

const handleUpdateExpired = async (payload: any) => {
  adminSetupStore
    .updateExpiredConfig(payload)
    .then(() => {
      adminSetupStore.getExpiredConfig().then((result) => {
        splitArrayByKey(result);
      });
      toast.add({ severity: 'success', summary: '', detail: t('notification.save_successfully'), life: 3000 });
    })
    .catch(() => {
      toast.add({ severity: 'error', summary: '', detail: t('notification.save_error'), life: 5000 });
    });
};

const getExpiredConfig = () => {
  isLoading.value = true;
  adminSetupStore
    .getExpiredConfig()
    .then((result) => {
      splitArrayByKey(result);
    })
    .finally(() => {
      isLoading.value = false;
    });
};
getExpiredConfig();
</script>
<template>
  <div class="email-config">
    <LoadingSpinner v-if="isLoading" />
    <div v-else class="card">
      <h4>{{ $t('management.email.email_configuration') }}</h4>
      <div class="flex flex-wrap justify-content-between mt-5">
        <div>
          <h5 class="title">{{ $t('management.email.email_notification_configuration') }}</h5>
          <div v-for="(item, emailIndex) in listEmailNoti" :key="emailIndex">
            <EmailConfigNumber :emailData="item" @handleSubmit="(payload) => handleUpdateExpired(payload)"></EmailConfigNumber>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
